import { jsxs, jsx } from 'react/jsx-runtime';
import classnames from '../../../../node_modules/classnames/index.js';
import { FooterButton } from './components/FooterButton/FooterButton.js';
import modules_93eb7477 from './Footer.module.scss.js';
import { CustomFooter } from '../CustomFooter/CustomFooter.js';

const Footer = ({ className, primary, secondary, tertiary, }) => {
    return (jsxs(CustomFooter, { className: classnames(modules_93eb7477.footer, className), children: [primary && (jsx(FooterButton, { appearance: "primary", className: modules_93eb7477.button, ...primary })), secondary && (jsx(FooterButton, { appearance: "secondary", ...secondary })), tertiary && (jsx(FooterButton, { appearance: "subtle", ...tertiary }))] }));
};

export { Footer };
//# sourceMappingURL=Footer.js.map
